import ModalItem from "./ModalItem";

// The menu is full-width on desktop, so its recommendation dialog gets a
// centered desktop presentation. ModalItem keeps the narrower customer flow.
const MenuModalItem = (props) => <ModalItem {...props} menuDesign />;

export default MenuModalItem;
